export const AccountHeaderWrapper =
  'flex flex-col xl:flex-row items-center text-black w-full justify-between'

export const AccountHeaderCustomerGreeting =
  'text-32 font-bold font-Lora leading-44 tracking-0'

export const AccountHeaderCustomerInfoWrapper =
  'flex pt-4 xl:pt-0 xl:justify-end items-center gap-5'

export const AccountHeaderCustomerInfoContent =
  'flex flex-col text-14 items-start justify-center font-Roboto leading-24 tracking-0 uppercase bg-black text-white px-4 py-3'

export const AccountHeaderCustomerInfoContentValue = `font-bold`
